// 运行环境与测试开关 - 三个测试相关判断的唯一来源
// (接口域名切换、?stage 覆盖白名单)

// 允许测试行为的 host 白名单: 本地开发 + 内网/外网测试机
const TEST_HOSTS = new Set([
  'localhost',
  '127.0.0.1',
  '172.27.84.57',
  '172.27.84.110',
  '39.107.229.24'
])

const hostname = (typeof window !== 'undefined' && window.location?.hostname) || ''
const search = (typeof window !== 'undefined' && window.location?.search) || ''

// 当前是否在测试 host 上 (允许 stage 覆盖等调试行为)
export const isTestHost = TEST_HOSTS.has(hostname)

// URL 是否带 ?env=test (开发者主动切到测试后端的开关)
export const isEnvTest = new URLSearchParams(search).get('env') === 'test'

// 接口是否走测试后端: 必须在测试 host + 主动加 ?env=test
// 双重保护避免线上用户用 ?env=test 把请求误打到测试机
export const useTestApi = isTestHost && isEnvTest